// FWSD-5066, user has to select another profile to be preferred when removes the current preferred profile

import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Button, Modal } from 'react-bootstrap'
import CustomButton from '../../CustomButton'

const DeletePreferredProfileModal = (props) => {

	const { profiles, profile, onHide, deleteProfile } = props;

	const [newProfileId, setNewProfileId] = useState(0);

	const selectNewProfile = (e) => {
		setNewProfileId(e.target.value);
	}

	return (
		<Modal
			show
			onHide={onHide}
			className="config-modal modal-lg-size"
		>
			<Modal.Header closeButton>
				<Modal.Title id="contained-modal-title-lg">Delete Preferred Profile ?</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div className="config-modal-body">
					<label><strong>{profile.name}</strong> is marked as a preferred profile. Please select a new existing profile to become the preferred profile.
						If a new profile is not selected, the <strong>Default</strong> profile will become the preferred profile.</label>
					<div className="text-center">
						<select
							name="profile-select"
							className="rosco-select"
							value={newProfileId}
							onChange={selectNewProfile}
						>
							<option hidden value={-1}>Select a new Profile...</option>
							{profiles.map((item) =>
								<option key={item.id} value={item.id} className="menu-item">{item.name}</option>
							)}
						</select>
					</div>
				</div>
			</Modal.Body>
			<Modal.Footer>
				<CustomButton variant="primary-outline" onClick={onHide}>
					Cancel
				</CustomButton>
				<CustomButton variant="primary" onClick={() => deleteProfile(newProfileId)}>
					Next
				</CustomButton>
			</Modal.Footer>
		</Modal>
	);
}

DeletePreferredProfileModal.propTypes = {
	profile: PropTypes.object.isRequired,
	profiles: PropTypes.arrayOf(PropTypes.object).isRequired,
	deleteProfile: PropTypes.func.isRequired,
	onHide: PropTypes.func.isRequired,
}

export default DeletePreferredProfileModal;
